// extracted by mini-css-extract-plugin
export default {"labelMargin":"TextArea_labelMargin__78oAo","InputStyle":"TextArea_InputStyle__cxZAU"};